import { AiOutlineMail } from "react-icons/ai";
import { Form, Formik, Field, ErrorMessage } from "formik";
import { TextError } from "../Helpers/InputContainer";
import {
  forgotEmailInitialValues,
  forgotEmailValidationSchema,
} from "@/constants/Auth";
import { resetTokenAPIRoute } from "@/services/auth/forgetPassword";
import { useTranslation } from "next-i18next";
import TurnstileRecaptcha from "../turnstile/TurnstileRecaptcha";
import { useTurnstile } from "react-turnstile";

function ForgotPassword({ setState }) {
  const {
    t,
    i18n: { language: lang },
  } = useTranslation("common");
  const turnstile = useTurnstile()

  const handleSubmit = async ({ email, token }, setFieldError, setFieldValue) => {
    const otpData = await resetTokenAPIRoute({ email, recaptchaToken: token }, setFieldError);
    if (otpData?.data?.data?.status == true) {
      setState((prev) => {
        return {
          ...prev,
          name: "verification-code",
          email,
          otp: '',
        };
      });
    } else {
      setFieldError("email", t("EmailIsNotExist"));
      turnstile.reset();
      setFieldValue("token", "");
    }
  };

  return (
    <section>
      <p className="my-3 text-zinc-600">{t("ForgotEmailDescription")}</p>
      <Formik
        initialValues={forgotEmailInitialValues}
        validationSchema={forgotEmailValidationSchema(t)}
        onSubmit={(values, { setFieldError }) =>
          handleSubmit(values, setFieldError)
        }
      >
        {({ isSubmitting, setFieldValue }) => (
          <Form>
            <div className="mb-2">
              <label
                className="block mb-1 font-semibold cursor-pointer"
                htmlFor="email"
              >
                {t("EmailAddress")}
              </label>
              <div className="relative">
                <Field
                  name="email"
                  className="w-full p-2 border rounded-md outline-0"
                  placeholder={t("EmailAddress")}
                  id="email"
                />
                <AiOutlineMail
                  size={24}
                  className={`absolute top-1/2 ${
                    lang === "en" ? "right-1" : "left-1"
                  } -translate-y-1/2 text-zinc-500`}
                />
              </div>
              <ErrorMessage name="email" component={TextError} />
            </div>
            <TurnstileRecaptcha
              action='forgot-password'
              className='flex justify-center items-center p-2'
              onVerify={(value) => {
                setFieldValue('token', value);
              }}
            />
            <button
              disabled={isSubmitting}
              type="submit"
              className="w-full p-2 font-semibold text-white rounded-md disabled:cursor-not-allowed bg-blue campaign:bg-campaignAccent border-red hover:bg-lightred"
            >
              {t(isSubmitting ? "Sending" : "Send")}
            </button>
          </Form>
        )}
      </Formik>
    </section>
  );
}

export default ForgotPassword;
